import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--jsm-sequoia/jsm-assets-app-navbar-data-manager-section';

import { type PlacementRenderProps } from '@post-office/browser--jsm-sequoia/jsm-assets-app-navbar-data-manager-section';

import type { MessageTemplateContext } from '../../..';

import { AssetsPremiumTrialDataManagerItem } from '../../../components/assets-premium-trial-data-manager-item';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({ dismiss, onItemClick, isSelected }: MessageFrontendProps) => (
			<AssetsPremiumTrialDataManagerItem
				dismiss={dismiss}
				onItemClick={onItemClick}
				isSelected={isSelected}
			/>
		),
	},
});
